const actions = {
  GET_SYMBOL_BEGIN: 'GET_SYMBOL_BEGIN',
  GET_SYMBOL_SUCCESS: 'GET_SYMBOL_SUCCESS',
  GET_SYMBOL_ERR: 'GET_SYMBOL_ERR',

  SET_SYMBOL_BEGIN: 'SET_SYMBOL_BEGIN',
  SET_SYMBOL_SUCCESS: 'SET_SYMBOL_SUCCESS',
  SET_SYMBOL_ERR: 'SET_SYMBOL_ERR',

  SET_FORECAST_HORIZON_BEGIN: 'SET_FORECAST_HORIZON_BEGIN',
  SET_FORECAST_HORIZON_SUCCESS: 'SET_FORECAST_HORIZON_SUCCESS',
  SET_FORECAST_HORIZON_ERR: 'SET_FORECAST_HORIZON_ERR',

  GET_MODEL_ID_BEGIN: 'GET_MODEL_ID_BEGIN',
  GET_MODEL_ID_SUCCESS: 'GET_MODEL_ID_SUCCESS',
  GET_MODEL_ID_ERR: 'GET_MODEL_ID_ERR',

  SET_MODEL_ID_BEGIN: 'SET_MODEL_ID_BEGIN',
  SET_MODEL_ID_SUCCESS: 'SET_MODEL_ID_SUCCESS',
  SET_MODEL_ID_ERR: 'SET_MODEL_ID_ERR',

  getSymbolBegin: () => {
    return {
      type: actions.GET_SYMBOL_BEGIN,
    };
  },

  getSymbolSuccess: data => {
    return {
      type: actions.GET_SYMBOL_SUCCESS,
      data,
    };
  },

  getSymbolErr: err => {
    return {
      type: actions.GET_SYMBOL_ERR,
      err,
    };
  },

  setSymbolBegin: () => {
    return {
      type: actions.SET_SYMBOL_BEGIN,
    };
  },

  setSymbolSuccess: data => {
    return {
      type: actions.SET_SYMBOL_SUCCESS,
      data,
    };
  },

  setSymbolErr: err => {
    return {
      type: actions.SET_SYMBOL_ERR,
      err,
    };
  },

  setForecastHorizonBegin: () => {
    return {
      type: actions.SET_FORECAST_HORIZON_BEGIN,
    };
  },

  setForecastHorizonSuccess: data => {
    return {
      type: actions.SET_FORECAST_HORIZON_SUCCESS,
      data,
    };
  },

  setForecastHorizonErr: err => {
    return {
      type: actions.SET_FORECAST_HORIZON_ERR,
      err,
    };
  },

  getModelIdBegin: () => {
    return {
      type: actions.GET_MODEL_ID_BEGIN,
    };
  },

  getModelIdSuccess: data => {
    return {
      type: actions.GET_MODEL_ID_SUCCESS,
      data,
    };
  },

  getModelIdErr: err => {
    return {
      type: actions.GET_MODEL_ID_ERR,
      err,
    };
  },

  setModelIdBegin: () => {
    return {
      type: actions.SET_MODEL_ID_BEGIN,
    };
  },

  setModelIdSuccess: data => {
    return {
      type: actions.SET_MODEL_ID_SUCCESS,
      data,
    };
  },

  setModelIdErr: err => {
    return {
      type: actions.SET_MODEL_ID_ERR,
      err,
    };
  },
};

export default actions;
